<hr />
<p class="kHelpLink" (click)="_openPowerUserPanel()">Open power-user console</p>

<kPowerUserConsole [(visible)]="_display"></kPowerUserConsole>
